var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var paymentMethodListItemTemplate = require('./paymentMethodListItemTemplate.hbs');
var applicationUtils = require('./../applicationUtils');
var PaymentDetailsFormModel = require('./../payment/PaymentDetailsFormModel');
var StoredPaymentMethodService = require('./StoredPaymentMethodService');

/**
 * View for displaying a payment method list item
 *
 * @class PaymentMethodListItemView
 * @constructor
 */
module.exports = TorsoView.extend({
  template: paymentMethodListItemTemplate,
  tagName: 'li',
  className: 'index__item index__item--wallet',

 /**
  * Handles clicks on submit and back buttons
  * @events
  */
  events: {
    'click [data-set-payment-method-as-default]': '_setAsDefault',
    'click [data-delete-payment-method]': '_deletePaymentMethod'
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function(options) {
    options = options || {};
    options.context = options.context || {};

    this._patientVecnaId = options.context.patientVecnaId;

    this._storedPaymentMethodService = new StoredPaymentMethodService({
      patientVecnaId: this.model.get('patientVecnaId')
    });
    this.listenTo(this._storedPaymentMethodService, 'change:errors', this.render);
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var templateContext = TorsoView.prototype.prepare.apply(this);

    templateContext.patientVecnaId = this._patientVecnaId;
    templateContext.needsAction = !this.model.get('valid');
    templateContext.errors = this._storedPaymentMethodService.get('errors');

    // Augment model for use in partial.
    _.extend(templateContext.model, {
      CARDS: PaymentDetailsFormModel.CARDS,
      PAYMENT_METHODS: PaymentDetailsFormModel.PAYMENT_METHODS,
      currentApplication: applicationUtils.currentApplication,
      expirationYear: this.model.getExpirationYear(),
      expirationMonth: this.model.getExpirationMonth()
    });
    return templateContext;
  },

  /**
   * @method _setAsDefault
   * @param event {Event} of click
   * @private
   */
  _setAsDefault: function(event) {
    if (event) {
      event.preventDefault();
    }
    var view = this;
    this.model.set('defaultPaymentMethod', true);
    this.model.save()
      .then(function () {
        view.model.trigger('fetchStoredPaymentMethods');
      });
  },

  /**
   * @method _deletePaymentMethod
   * @param event {Event} of click
   * @private
   */
  _deletePaymentMethod: function(event) {
    if (event) {
      event.preventDefault();
    }
    this._storedPaymentMethodService.deletePaymentMethod(this.model);
  },

  /**
   * @method _dispose
   * @private
   * @override
   */
  _dispose: function() {
    this._storedPaymentMethodService.dispose();
  }
});
